<template>
  <p>
    <label>
      <input
        type="radio"
        :value="true"
        :checked="value === true"
        @change="$emit('input', $event.target.value === 'true')"
      />
      With Tolerances
    </label>

    <label>
      <input
        type="radio"
        :value="false"
        :checked="value === false"
        @change="$emit('input', $event.target.value === 'true')"
      />
      Without Tolerances
    </label>
  </p>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped>
input {
  display: inline-block !important;
  height: 24px !important;
  margin: 0 4px 0 0 !important;
  vertical-align: top;
  width: auto !important;
}

label {
  margin-bottom: 0;
}

label.inline {
  display: inline-block;
  height: 24px;
  margin-right: 10px;
  vertical-align: top;
}

p {
  margin-bottom: 20px;
}
</style>
